import { Offcanvas } from 'bootstrap'

// TODO.md F-152. **Opening a record: the offcanvas on a click, a real page in a new tab.**
//
// 🚨 **The link needs two urls, and giving it one was the defect.** Each index's first column carried only
// the `edit` path with `remote: true`, so a middle-click issued a plain HTML GET of an action that answers
// JS. Customers and clients papered over it by giving `edit` a `format.html` that redirected to the index
// with an id param, which the index echoed into a hidden input for a pack to read back and re-request —
// **three requests to show one record, across four hand-written places, duplicated in two packs.** Users and
// contract people had none of it, so a new tab landed on the root path.
//
// ✅ Now `href` is the page and `data-offcanvas-url` is the fragment (`ApplicationHelper#record_link`). A
// middle-click opens the href: **one request, no redirect**, and `edit` is JS-only again.
//
// 🔑 **Bound once, for every table, with no per-pack knowledge.** The old shape needed each pack to know its
// own table id *and* its own edit path; here the server renders both urls, so this file reads attributes and
// nothing else. That is also why it can live in `application.js`'s single init rather than in four packs —
// the same reasoning as `T-108`'s `index:refresh`: prefer a mechanism that is correct by construction over
// one each caller has to re-implement.
// ⚠️ **`Offcanvas.getOrCreateInstance`, not the `offcanvasRight` global — and that was a real bug, not
// caution.** The global is `null` until `application.js` constructs it part-way through
// `turbolinks:load`, so calling this before that point threw on null and all four landings silently did
// nothing. 🔑 Rather than move the call to a position where the global happens to exist — an ordering
// requirement of exactly the kind `T-108` was filed to delete — this asks Bootstrap for the instance and
// is correct wherever it runs. `getOrCreateInstance` returns the existing one when there is one, so the
// click path and `application.js` keep sharing a single instance.
function offcanvas() {
  const element = document.getElementById('offcanvasRight')

  return element && Offcanvas.getOrCreateInstance(element)
}

// The two callers below differ only in where the url comes from, so the pair that must stay in step — show
// the panel, then fetch the fragment — lives here once.
function open(url) {
  offcanvas()?.show()
  $.getScript(url)
}

export default function initOpenRecord() {
  // ⚠️ Namespaced `off()` before `on()`, per CLAUDE.md → *Pack Initialisation*: idempotent by construction,
  // so it cannot double-bind however many initialisers reach it.
  $('#content').off('click.openRecord')
  $('#content').on('click.openRecord', 'a[data-offcanvas-url]', function (event) {
    // 🚨 **Let a modified click through to the browser — this is the whole point of the change.** Ctrl/⌘
    // click fires a normal `click` event, so without this the handler would swallow exactly the gesture
    // F-152 exists to support. (A middle-click fires `auxclick`, not `click`, so it never reaches here.)
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    event.preventDefault()
    open($(this).data('offcanvasUrl'))
  })

  // The new-tab landing: the index rendered `data-open-record-url` because its `?<record>_id=` param
  // resolved to a record this user may see. Absent — the ordinary case — this does nothing.
  const opening = document.querySelector('[data-open-record-url]')

  if (opening) {
    open(opening.dataset.openRecordUrl)
  }
}
